import { Component, OnInit } from "@angular/core";
import { NavigationEnd, Router } from "@angular/router";

import { RouteEventsService, UserService } from "../shared";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: [],
})
export class AppComponent implements OnInit {
  public title = "uMuzi";

  constructor(
    private router: Router,
    private routeEventsService: RouteEventsService,
    private userService: UserService
  ) {}

  ngOnInit() {
    this.router.events.subscribe((evt) => {
      if (!(evt instanceof NavigationEnd)) {
        return;
      }
      window.scrollTo(0, 0);
    });

    this.userService.populate();
    this.routeEventsService.saveRoutes();
  }
}
